import type { ConversationItem } from '../types/conversationItem.types';

export const suppressDuplicateInfoCards = (
  response: ConversationItem,
  seenInfoCardStackIds: Set<string>
): ConversationItem => {
  if (!response.showInfoCards || !response.infoCardStackId) {
    return response;
  }

  if (seenInfoCardStackIds.has(response.infoCardStackId)) {
    return {
      ...response,
      showInfoCards: false,
      infoCardStackId: undefined,
      infoCardsContext: undefined,
    };
  }

  seenInfoCardStackIds.add(response.infoCardStackId);
  return response;
};
